import React from "react";
import "./Introduction.css";

const Introduction = () => {
  const scrollToContact = () => {
    const contactSection = document.querySelector(".contact-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="introduction-div">
      <div className="about">
        <h1>
          Your Trusted Partner in Engineering Solutions & Steel Fabrication
          Since 2018
        </h1>
        <h3>Commercial Construction</h3>
      </div>

      <button className="contact-button" onClick={scrollToContact}>
        Get a Free Consultation
      </button>
    </div>
  );
};

export default Introduction;
